// Global endpoints
const PREVIEW_URL = 'https://mono.homebodii.com/api/preview'
const COORDINATES_URL = 'https://mono.homebodii.com/api/view_coordinates'
const IMAGE_URL = 'https://mono.homebodii.com/api/saveImage'
let charLimit = 0

var personalization = {
  defaults: {},
  init: ()=> {
    var vm = personalization
    vm.renderWidget()
    vm.renderText()
    vm.addToCart()

    document.querySelector('.modal-overlay').addEventListener('click', vm.closePopup)
    
    document.querySelector('[data-close-modal]').addEventListener('click', vm.closePopup)
  
    document.querySelector('.button--next').addEventListener('click', vm.nextStep)

    document.querySelector('.button--back').addEventListener('click', vm.prevStep)
  },

  load: ()=> {},

  getPreviewData: () => {
    personalization.getString()

    axios.get(PREVIEW_URL, {
      params: {
        shop: 'homebodii-uat.myshopify.com',
        sample_text: document.querySelector('.personalisation-widget__field--hidden').textContent,
        position: document.querySelector('.position-option.active').dataset.areaCode,
        product_id: document.querySelector('[data-personalization-widget]').dataset.product,
        font: document.getElementById('font-select').value,
        colour: document.querySelector('.personalisation-widget__colours a.active').dataset.hexValue
      }
    })
    .then(function (res) {
      personalization.getEncodedImg(res.data.encoded_image)
    })
    .catch(function (error) {
      console.log('err', error);
    });
  },

  renderWidget: e => {
    const vm = personalization
    const widget = document.querySelector('[data-personalization-widget]')
    
    if (!widget) { 
      return false 
    }

    // Get the data from API endpoint
    axios.get(COORDINATES_URL, {
      params: {
        shop: 'homebodii-uat.myshopify.com',
        product_id: widget.dataset.product
      }
    })
    .then(function (response) {
      if ('coordinates' in response.data) {
        // Render Coordinates
        vm.getCoordinates(response)

          // Render personalization button
        if (!widget.querySelector('[data-personalization-button]')) {
          widget.innerHTML= `
                  <div class="image">
                    <img width="103" height="103" src="https://cdn.shopify.com/s/files/1/0423/2540/9943/files/Frame_12.jpg?v=1741169266">
                  </div>
                  <div class="content">
                    <p>
                      Add a personal touch for free. All with your choice of colour, font, placement and symbol.
                    </p>
                                      </div>                  
            <div class="plus">
                    <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 32C25.4558 32 31.5 25.9558 31.5 18.5C31.5 11.0442 25.4558 5 18 5C10.5442 5 4.5 11.0442 4.5 18.5C4.5 25.9558 10.5442 32 18 32Z" stroke="#050505" stroke-miterlimit="10"/>
                    <path d="M12.375 18.5H23.625" stroke="#050505" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M18 12.875V24.125" stroke="#050505" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>`
           widget.querySelector('.content').appendChild(vm.renderButton());
          widget.style.display = 'flex';
          // Adding logic for ticket HOM-3, this is so we can add pickup attributes to the personalisation section
          // initPropertiesChangeToButton is a function from the theme.js file
          const personalisationButton = widget.querySelector('[data-personalization-button]')
          const parentForm = widget.closest('form') ? widget.closest('form') : null;
          if (!personalisationButton) {
            console.error('Button has not been initialised or does not exist')
            return
          }
          initPropertiesChangeToButton(personalisationButton, parentForm);
          // Add css to giftnote button shadow DOM if it exists
          const host = document.querySelector('giftnote-voucher-button');
          if (host && host.shadowRoot) {
            var style = document.createElement( 'style' )
            style.innerHTML = '#container{  justify-content: left;}#container > button { text-align: left;border: none; text-decoration:underline;border-radius: 0;padding: 0;height: auto;width: fit-content;font-size: 14px;font-family: Nunito Sans,sans-serif;color: #57585b !important;font-weight: bold; }';
            host.shadowRoot.appendChild( style )
          }
        }
      }
    })
    .catch(function (error) {
      console.log('err', error);
    });

  },

  renderButton: e => {
    const vm = personalization
    const button = document.createElement('a')
    button.setAttribute('data-personalization-button', '')
    button.classList.add('button')
    button.textContent = 'Add Complimentary Personalisation'

    button.addEventListener('click', e => {
      vm.openPopup()
      vm.getProductObj(e)
      vm.renderWidget()
    })

    return button
  },

  getCoordinates: response => {
    const parent = document.querySelector('.widget-position')

    if (parent.querySelectorAll('.position-option').length == 0) {
      // Get coordinates
      response.data.coordinates.forEach(coordinate => {
        const btn = document.createElement('a')
        btn.classList.add('position-option')
        btn.setAttribute('data-area-code', coordinate.area_code)
        btn.setAttribute('href', 'javascript:void(0)')
        btn.textContent = coordinate.area_name
  
        document.querySelector('.widget-position').appendChild(btn)
      });

      personalization.getOptions()
    }
  },

  getOptions: () => {
    const vm = personalization
    const options = document.querySelectorAll('.position-option')
    options.forEach(option => {
      option.addEventListener('click', e => {
        e.preventDefault();
        const position = e.target.dataset.areaCode
        const id = document.querySelector('[data-personalization-widget]').dataset.product
        document.querySelector('.personalisation-widget__option').style.display = 'none'

        // Toggle active class of options
        const active = document.querySelector('.position-option.active')
        if (active) {
          active.classList.remove('active')
        }
        e.target.classList.add('active')

        const params = {
          shop: 'homebodii-uat.myshopify.com',
          text: 'HB',
          position: position,
          product: id,
          font: 'garmnd',
          color: 'e8b9b4'
        }

        axios.get(PREVIEW_URL, {
          params: {
            shop: params.shop,
            sample_text: params.text,
            position: params.position,
            product_id: params.product,
            font: params.font,
            colour: params.color
          }
        })
        .then(function (res) {
          const fonts = res.data.available_fonts
          vm.setText('HB')
          vm.getFontImg(fonts[0].font_sample_image)
          vm.getFonts(fonts)
          vm.getCombination(res.data)
          vm.getEncodedImg(res.data.encoded_image)
          vm.getColours(res.data)
          vm.setCharLimit(res.data)
          vm.charCounter()
        })
        .catch(function (error) {
          console.log('err', error);
        });

      })
    }) 

  },

  getEncodedImg: url => {
    const img = document.querySelector('.img-container img')
    img.setAttribute('src', `data:image/png;base64,${url}`)
  },

  getFontImg: url => {
    const image = document.querySelector('.select-group .font-image')
    image.style.backgroundImage = `url(${url})`
  },

  getFonts: fonts => {
    const select = document.getElementById('font-select')

    // Reset dropdown options
    while (select.options.length > 0) {
      select.remove(0);
    }

    // Popuplate select options
    fonts.forEach(font => {
      const optionElement = document.createElement('option');
      optionElement.text = font.font_name;
      optionElement.value = font.font_code;
      select.add(optionElement);
    });

    // Update font image upon font selection
    select.addEventListener('change', e => {
      const selected = fonts.find(obj => obj.font_code === e.target.value);

      personalization.getFontImg(selected.font_sample_image)
      personalization.getPreviewData()
      
    })
  },

  getCombination: data => {
    const select = document.getElementById('combination-select')
    const options = []

    // Reset dropdown options
    while (select.options.length > 0) {
      select.remove(0);
    }

    // Add `text` as default option
    options.push('text')

    // Check if emojis are available
    const emojis = data.emojis_available
    if (emojis !== 0) {

      // If has emoji type `emoji`
      const hasEmoji = emojis.some(emoji => emoji.type === 'emoji')
      if (hasEmoji) {
        options.push('emoji')
      } 
      
      // If has emoji type `motiff`
      const hasMotiff = emojis.some(emoji => emoji.type === 'motiff')
      if (hasMotiff) {
        options.push('motiff')
      }

      // If has emoji type `crest`
      const hasCrest = emojis.some(emoji => emoji.type === 'crest')
      if (hasCrest) {
        options.push('crest')
      }

    }

    // Create option placeholder
    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.text = 'Choose personalisation combination';
    placeholder.disabled = true;
    placeholder.selected = true;
    select.insertBefore(placeholder, select.firstChild);

    options.forEach(option => {
      let text = ''
      if (option == 'emoji') {
        text = 'Add Text and Emoji'
      } else if (option == 'motiff') {
        text = 'Add Motif only'
      } else if (option == 'crest') {
        text = 'Add Initial and Crest'
      } else {
        text = 'Add Text'
      }

      const optionElement = document.createElement('option');
      optionElement.text = text;
      optionElement.value = option;
      select.add(optionElement);
    })

    // Bind event in options
    personalization.selectCombination(data)

  },

  selectCombination: data => {
    const vm = personalization
    const select = document.getElementById('combination-select')

    select.addEventListener('change', e => {

      document.querySelector('.personalisation-widget__option').style.display = 'block'

      const optionGroup = document.querySelector('.personalisation-widget__option') 

      const fieldGroup = optionGroup.querySelector('.text-field-group')
      fieldGroup.style.display = e.target.value == 'motiff' ? 'none' : 'block'
      
      const emojiLabel = optionGroup.querySelector('.emoji-label')
      emojiLabel.style.display = e.target.value == 'text' ? 'none' : 'block'
      emojiLabel.textContent = `CHOOSE ${e.target.value.toUpperCase()}: `

      const description = optionGroup.querySelector('.description')
      description.style.display = e.target.value == 'text' ? 'none' : 'block'

      const note = optionGroup.querySelector('.note span')
      optionGroup.querySelector('.note').style.display = e.target.value == 'text' ? 'none' : 'block'

      if (e.target.value == 'emoji') {
        note.textContent = 'Adding an emoji will reduce your text character allowance.'
        vm.clearText()
        vm.setText('HB')

      } else if (e.target.value == 'motiff') {
        note.textContent = 'Motif is picture only. Size may vary to app.'
        vm.clearText()
        
      } else if (e.target.value == 'crest') {
        note.textContent = 'Initials will sit within Crest. You are allowed 1 uppercase initial with crest option'
        vm.clearText()
      } else {
        vm.setText('HB')
      }

      // Filter and get emojis
      vm.getEmojis({
        emojis: data.emojis_available,
        value: e.target.value
      })

      vm.getPreviewData()

    })

  },

  getEmojis: params => {
    const container = document.querySelector('.personalisation-widget__assets')

    // Clear emojis before populating filtered object
    while (container.firstChild) {
      container.removeChild(container.firstChild);
    }

    // Filter emoji based on type
    const filtered = params.emojis.filter(emoji => emoji.type == params.value)

    filtered.forEach(obj => {
      // Create option element
      const a = document.createElement('a')
      a.setAttribute('href', 'javascript:void(0)')
      a.classList.add('option-image', obj.type)

      // Create image option
      const img = document.createElement('img')
      img.setAttribute('src', obj.emoji_image)
      img.setAttribute('data-name', obj.emoji_reference)
      img.setAttribute('data-char-count', obj.emoji_char_count)
      a.appendChild(img)

      // Append created option in wrapper
      container.appendChild(a)
    })
    // personalization.selectCrest()
    personalization.selectEmoji()
    // personalization.selectMotif()
    
  },

  selectEmoji: () => {
    const vm = personalization
    const emojis = document.querySelectorAll('.personalisation-widget__assets a')

    const handleClick = e => {
      e.preventDefault();
      const textField = document.querySelector('.personalisation-widget__field')
      const charCount = parseInt(e.target.dataset.charCount)
      const sum = vm.getTotalChar() + charCount

      if (sum > charLimit) {
        vm.showErrorMessage({
          errorMsg: 'Character count limit reached.',
          parent: document.querySelector('.text-field-group')
        })
        return false
      }

      // Create a new range at the current selection
      const range = window.getSelection().getRangeAt(0);

      const parent = e.srcElement.parentElement
      if (parent.classList.contains('motiff') || parent.classList.contains('crest')) {
        vm.clearText()
      }

      // Create a new element for the image
      const image = document.createElement('img');
      image.src = e.target.src;
      image.setAttribute('data-name', e.target.dataset.name)
      image.setAttribute('data-char-count', e.target.dataset.charCount)

      if (range.commonAncestorContainer === textField || textField.contains(range.commonAncestorContainer)) {
        range.insertNode(image);
        textField.appendChild(range.extractContents());
        range.collapse(false);

      } else {
        textField.focus()
        const range = window.getSelection().getRangeAt(0);
        range.insertNode(image);
        textField.appendChild(range.extractContents());
        range.insertNode(image);
        range.collapse(false);
      }

      vm.charCounter()
      vm.getPreviewData()
    }

    emojis.forEach(emoji => {
      emoji.addEventListener('click', handleClick)
    })
  },

  getColours: data => {
    const container = document.querySelector('.personalisation-widget__colours')

    while (container.firstChild) {
      container.removeChild(container.firstChild);
    }

    data.available_threads.forEach((color, i) => {
      const a = document.createElement('a')
      a.setAttribute('href', 'javascript:void(0)')
      a.setAttribute('title', color.colour_name)
      a.setAttribute('data-hex-value',  color.colour_code.replace('#', ''))
      a.style.backgroundColor = color.colour_code

      if (i === 0) {
        a.classList.add('active')
      }

      container.appendChild(a)
    })

    personalization.getSelectedColour()
  },

  getSelectedColour: e => {
    const colors = document.querySelectorAll('.personalisation-widget__colours a')

    colors.forEach(color => {
      color.addEventListener('click', e => {
        e.preventDefault();
        // Remove previously selected color
        const selected = document.querySelector('.personalisation-widget__colours a.active')
        selected.classList.remove('active')
        e.target.classList.add('active')

        personalization.getPreviewData()
      })
    })
  },

  renderText: () => {
    const vm = personalization
    const field = document.querySelector('.personalisation-widget__field')

    if (!field) {
      return false
    }

    field.addEventListener('keyup', e => {
      if (vm.validateCharLimit()) {
        document.execCommand('undo', false, null)
        return false
      }

      vm.charCounter()
      vm.getPreviewData()
    })
  },

  getString: () => {
    const hidden = document.querySelector('.personalisation-widget__field--hidden')
    const field = document.querySelector('.personalisation-widget__field')
    let string = ''

    let childNodes = field.childNodes;
    
    for (let i = 0; i !== childNodes.length; i += 1) {
      let node = childNodes[i];

      if (node.nodeType === Node.TEXT_NODE) {
        string += node.textContent.trim()
      } else if (node.nodeName === "IMG") {
        string += node.dataset.name
      }
    }

    hidden.textContent = string
  },

  setCharLimit: (data) => {
    charLimit = data.rules.char_limit
  },

  getTotalChar: () => {
    const field =  document.querySelector('.personalisation-widget__field')
    let childNodes = field.childNodes;
    let count = 0
    
    for (let i = 0; i !== childNodes.length; i += 1) {
      let node = childNodes[i];

      // Check if the child node is a text node
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== "") {
        const text = node.textContent.trim()
        // Loop through each character in the text node
        for (let j = 0; j !== text.length; j += 1) {
          count += 1
        }
      } else if (node.nodeName === "IMG") {
        count += parseInt(node.dataset.charCount)
      } 
    }

    return count
  },

  charCounter: () => {
    const vm = personalization
    document.querySelector('.text-label small').textContent = `${vm.getTotalChar()}/${charLimit}`
  },

  validateCharLimit: () => {
    const vm = personalization
    let count = personalization.getTotalChar()
    let limitReached = false

    if (count > charLimit) {
      vm.showErrorMessage({
        errorMsg: 'Character count limit reached.',
        parent: document.querySelector('.text-field-group')
      })
      limitReached = true
    } else {
      vm.hideErrorMessage()
      limitReached = false
    }

    return limitReached
  },

  showErrorMessage: (params) => {
    if (document.querySelector('.error-message') == null) {
      const div = document.createElement('div')
      div.classList.add('error-message')
      div.textContent = params.errorMsg                                                                                       
      params.parent.appendChild(div)
    }
  },

  hideErrorMessage: () => {
    const errorMsg = document.querySelector('.error-message')
    if (errorMsg != null) {
      errorMsg.remove()
    }
  },

  clearText: () => {
    const field = document.querySelector('.personalisation-widget__field')
    while (field.firstChild) {
      field.removeChild(field.firstChild);
    }

    const hidden = document.querySelector('.personalisation-widget__field--hidden')
    hidden.textContent = ''
  },

  setText: text => {
    const field = document.querySelector('.personalisation-widget__field')
    while (field.firstChild) {
      field.removeChild(field.firstChild);
    }

    field.textContent = text

    const hidden = document.querySelector('.personalisation-widget__field--hidden')
    hidden.textContent = text
  },

  openPopup: () => {
    const popup = document.getElementById('personalization-popup')
    popup.style.display = 'block'
    popup.style.visibility = 'visible'
    document.body.classList.add('personalization-popup-open')
    document.body.style.overflow = 'hidden'
   
    document.querySelector('.button--next').style.display = 'block' 
    document.querySelector('[data-mono-add-to-cart]').style.display = 'none' 
  },

  closePopup: () => {
    const vm = personalization
    const popup = document.getElementById('personalization-popup')
    popup.style.display = 'none'
    popup.style.visibility = 'hidden'
    document.body.classList.remove('personalization-popup-open')
    document.body.style.overflow = ''

    const title = popup.querySelector('.title-row')
    vm.removeChildrenNodes(title)

    const options = popup.querySelector('.input-row')
    vm.removeChildrenNodes(options)

    const positions = popup.querySelector('.widget-position')
    vm.removeChildrenNodes(positions)

    const img = popup.querySelector('.img-container')
    vm.removeChildrenNodes(img)

    const activeTab = popup.querySelector('.tab-panel.active')
    activeTab.classList.remove('active')

    const firstTab = popup.querySelector('.tab-panel[data-step="1"]')
    firstTab.classList.add('active')
  },

  nextStep: e => {
    const vm = personalization
    const addToCartBtn = document.querySelector('[data-mono-add-to-cart]')

    if (!addToCartBtn) {
      return false
    }

    const activePanel = document.querySelector('.tab-panel.active')
    let step = parseInt(activePanel.dataset.step)

    console.log('step', step)

    if (step == 4) {
      return false
    }

    if (!personalization.validateSelectedOption()) {
      vm.showErrorMessage({
        errorMsg: 'Please select a position.',
        parent: document.querySelector('.tab-panel[data-step="1"]')
      })
      return false
    } else {
      vm.hideErrorMessage()
    }
    
    // Hide current step
    const currentPanel = document.querySelector(`[data-step="${step}"]`)
    currentPanel.classList.remove('active')

    // Show next step
    const nextStep = step+=1
    const nextPanel = document.querySelector(`[data-step="${nextStep}"]`)
    nextPanel.classList.add('active')

    e.target.style.display = (nextStep == 4) ? 'none' : 'block'
    addToCartBtn.style.display = (nextStep == 4) ? 'block' : 'none'
  },

  prevStep: (e) => {
    e.preventDefault();
    const nextButton = document.querySelector('.button--next')
    const addToCartBtn = document.querySelector('[data-mono-add-to-cart]')

    const activePanel = document.querySelector('.tab-panel.active')
    let step = parseInt(activePanel.dataset.step)

    if (step == 1) {
      return false
    }
    
    // Hide current step
    let currentPanel = document.querySelector(`[data-step="${step}"]`)
    currentPanel.classList.remove('active')

    // Show previous step
    let prevStep = step - 1
    const prevPanel = document.querySelector(`[data-step="${prevStep}"]`)
    prevPanel.classList.add('active')

    nextButton.style.display = (prevStep > 3) ? 'none' : 'block'
    addToCartBtn.style.display = (prevStep == 4) ? 'block' : 'none'
  },

  validateSelectedOption: () => {
    // Get all options with the same class name
    const options = Array.from(document.getElementsByClassName('position-option'));
    let hasSelectedOption = false

    // Check if the specific class name is present in any of the options
    const activeClass = 'active';
    const allElementsLackSpecificClass = options.every(element => !element.classList.contains(activeClass));

    if (!allElementsLackSpecificClass) {
      hasSelectedOption = true
    }

    return hasSelectedOption
  },

  getFontText: () => {
    const select = document.getElementById('font-select')
    const option = select.options[select.selectedIndex];
    const text = option.text;

    return text
  },

  addToCart: () => {
    const vm = personalization
    const button = document.querySelector('[data-mono-add-to-cart]')

    const getImgURL = async () => {
      try {
        const response = await axios.get(IMAGE_URL, {
          params: {
            shop: 'homebodii-uat.myshopify.com',
            sample_text: document.querySelector('.personalisation-widget__field--hidden').textContent,
            position: document.querySelector('.position-option.active').dataset.areaCode,
            product_id: document.querySelector('[data-personalization-widget]').dataset.product,
            font: document.getElementById('font-select').value,
            colour: document.querySelector('.personalisation-widget__colours a.active').dataset.hexValue
          }
        })
        const imgUrl = response.data.image_url; 
        return imgUrl;
      } catch (error) {
        console.error('Error fetching image URL:', error);
        throw error; // Throw the error to be caught by the caller of getImgURL() if needed
      }
    };

    const addToCart = async () => {
      try {
        const imgUrl = await getImgURL();
        
        // Get selected variant ID from radio buttons in modal (scope to modal only)
        const modal = document.getElementById('personalization-popup');
        const selectedVariant = modal.querySelector('.js-option:checked');
        if (!selectedVariant) {
          console.error('No variant selected in modal');
          return;
        }
        console.log('Selected variant element:', selectedVariant, 'value:', selectedVariant.value, 'data-attr:', selectedVariant.getAttribute('data-variant-id'));
        const variantId = parseInt(selectedVariant.getAttribute('data-variant-id') || selectedVariant.value);
        
        let product;
        const preOrderField = document.querySelector('#properties-pre-order');
        if (!preOrderField || preOrderField.value == "") {
          product = {
            id: variantId,
            quantity: parseInt(document.getElementById('mono-quantity').value),
            properties: {
              "Colour": document.querySelector('.personalisation-widget__colours a.active').title,
              "Font": vm.getFontText(),
              "Position": document.querySelector('.position-option.active').text,
              "Text": document.querySelector('.personalisation-widget__field--hidden').textContent,
              "_image_url": imgUrl
            } 
          };
        } else {
          product = {
            id: variantId,
            quantity: parseInt(document.getElementById('mono-quantity').value),
            properties: {
              "Colour": document.querySelector('.personalisation-widget__colours a.active').title,
              "Font": vm.getFontText(),
              "Position": document.querySelector('.position-option.active').text,
              "Text": document.querySelector('.personalisation-widget__field--hidden').textContent,
              "Pre-order": document.querySelector('#properties-pre-order').value,
              "_image_url": imgUrl
            } 
          };
        }

        const deliveryAvailabilityText = document.querySelector('.js-availability');
        const pickUpAvailabilityText = document.querySelector('.store-availability-information__title');

        if (deliveryAvailabilityText && pickUpAvailabilityText) {
          product.properties['Delivery Availability'] = deliveryAvailabilityText.innerText.trim();
          product.properties['Pickup Availability'] = pickUpAvailabilityText.innerText.trim();
        }

        console.log('Adding to cart with product:', product);
        await axios.post('/cart/add.js', product); 
        
        // Close modal and open cart drawer
        personalization.closePopup();
        
        // Refresh and open cart drawer using Symmetry theme events
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
          bubbles: true
        }));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));

      } catch (error) {
        console.error('Error adding product to cart:', error);
      }
    };

    button.addEventListener('click', addToCart)
  },

  getProductObj: e => {
    const vm = personalization
    const widget = e.target.closest('[data-personalization-widget]')
    const handle = widget.dataset.productHandle
    const url = `${window.Shopify.routes.root}products/${handle}.js`


    axios.get(url)
    .then(res => {
      const id = widget.dataset.product
      vm.getVariantOption(res.data, id)
      vm.renderProductTitle(res.data)
      vm.renderImg(res.data)
    })
    .catch(error => {
      console.log('err', error);
    });

  },

  getVariantOption: (product, id) => {
    const variantSelector = document.querySelector('.form-container .input-row')
    const radios = [];

    // Check if option-selectors already exists, if so remove it
    const existingSelectors = variantSelector.querySelector('.option-selectors')
    if (existingSelectors) {
      existingSelectors.remove()
    }

    const selectors = document.createElement('div')
    selectors.classList.add('option-selectors')
    variantSelector.appendChild(selectors)

    const optionSelector = document.createElement('div')
    optionSelector.classList.add('option-selector')
    selectors.appendChild(optionSelector)

    const fieldset = document.createElement('fieldset')
    fieldset.classList.add('option-selector-fieldset')
    optionSelector.appendChild(fieldset)

    const labelParent = document.createElement('div')
    labelParent.classList.add('opposing-items')
    labelParent.innerHTML = `<legend class="label">${product.options[0].name}</legend>`
    fieldset.appendChild(labelParent)

    const buttons = document.createElement('div')
    buttons.classList.add('option-selector__btns')
    fieldset.appendChild(buttons)

     // Find the index of the first available variant
     let firstAvailableIndex = product.variants.findIndex((variant) => variant.available);

     // If the first variant is not available, find the nearest available variant
     if (firstAvailableIndex === -1) {
         firstAvailableIndex = product.variants.findIndex((variant) => variant.available);
     }
    
    product.variants.forEach((variant, i) => {
      // create the radio button element
      const radio = document.createElement("input");
      radio.type = "radio";
      radio.name = `${id}-size-selector`;
      radio.value = variant.id;
      radio.setAttribute('data-variant-id', variant.id);
      radio.required = true
      radio.classList.add('opt-btn', 'js-option')
      radio.id = `${id}-size-selector-opt-${i}`
      
      console.log('Creating radio for variant:', variant.id, variant.title);

      if (!variant.available) {
        radio.classList.add('is-unavailable')

      } 

      if (i === firstAvailableIndex) {
        radio.checked = true
      } 
      
      // create the label for the radio button
      const label = document.createElement("label");
      label.innerHTML = `<span class="opt-label__text">${variant.title}</span>`;
      label.setAttribute('for', `${id}-size-selector-opt-${i}`)
      label.classList.add('opt-label')
      
      // add the radio button and label to the array
      radios.push(radio);
      radios.push(label);
    });
  
    // add the radio buttons to the variant selector element
    buttons.append(...radios);
    personalization.syncSelectedVariant()
  },

  renderProductTitle: product => {
    const parent = document.querySelector('.form-container .title-row')
    
    const heading = document.createElement('h1')
    heading.classList.add('title')
    heading.textContent = product.title

    parent.appendChild(heading)
  },

  removeChildrenNodes: parent => {
    const children = parent.childNodes
    const arr = Array.from(children);

    arr.forEach(function(children) {
      parent.removeChild(children);
    })
  },

  renderImg: data => {
    const parent = document.querySelector('.img-container')

    const img = document.createElement('img')
    img.setAttribute('src', data.featured_image)

    parent.appendChild(img)
  },

  syncSelectedVariant: () => {
    const options = document.querySelectorAll('.option-selector__btns input')
    let isAvailable = true

    options.forEach(option => {
      option.addEventListener('click', e => {
        const value = e.target.value

        if (e.target.classList.contains('is-unavailable')) {
          isAvailable = false
        } else {
          isAvailable = true
        }

        personalization.toggleAddToCart(isAvailable)
       
        options.forEach(selected => {
          if (selected.value === value) {
            selected.click()
          }
        })
      })
    })

  },

  toggleAddToCart: status => {
    const button = document.querySelector('[data-mono-add-to-cart]')

    button.disabled = status ? false : true
    button.textContent = status ? 'Add to Cart' : 'Sold Out'
  },
}


document.addEventListener('DOMContentLoaded', function() {
  if (window.location.href.indexOf('/products/') > -1) {
    personalization.init()
  }
});
